import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DIALOG_DATA,
  DialogRef,
  ForgeIconButtonModule,
  ForgeIconModule,
  ForgeScaffoldModule,
  ForgeToolbarModule
} from '@tylertech/forge-angular';

export interface EnlargedMugshotModalData {
  imageUrl: string;
  inmateName?: string;
}

@Component({
  selector: 'app-enlarged-mugshot-modal',
  standalone: true,
  imports: [
    CommonModule,
    ForgeScaffoldModule,
    ForgeToolbarModule,
    ForgeIconButtonModule,
    ForgeIconModule
  ],
  templateUrl: './enlarged-mugshot-modal.component.html',
  styleUrls: ['./enlarged-mugshot-modal.component.scss']
})
export class EnlargedMugshotModalComponent {
  constructor(
    @Inject(DIALOG_DATA) public data: EnlargedMugshotModalData,
    private readonly _dialogRef: DialogRef
  ) {}

  closeDialog(): void {
    this._dialogRef.close();
  }
}